module.exports = __webpack_public_path__ + "static/img/Gold2.03a5e60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Gold2.svg
// module id = 6dTJ
// module chunks = 35